import { ApplicationRoleCode } from '@kcftech/prometheustypescriptapiclient';
import { usePermissions } from 'contexts/PermissionsContext';
import { applicationRoleToName } from 'pages/Settings/Users/shared';
import { useMemo } from 'react';
import { excludeNullAndUndefined } from 'utils/array';

export function useValidUserRoleOptions() {
    const { canAddSentry, canAddSaas, canAddSales, canAddUsers } = usePermissions();
    const userRoleOptions = useMemo(
        () =>
            excludeNullAndUndefined([
                canAddUsers
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.User],
                          value: ApplicationRoleCode.User,
                      }
                    : undefined,
                canAddSales
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.Sales],
                          value: ApplicationRoleCode.Sales,
                      }
                    : undefined,
                canAddSentry
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.Sentry],
                          value: ApplicationRoleCode.Sentry,
                      }
                    : undefined,
                canAddSaas
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.SystemAdmin],
                          value: ApplicationRoleCode.SystemAdmin,
                      }
                    : undefined,
            ]),
        [canAddSaas, canAddSales, canAddSentry, canAddUsers]
    );

    return userRoleOptions;
}
